import { render, staticRenderFns } from "./wy-experience-and-automation-page-legacy.vue?vue&type=template&id=0e153b5f&"
import script from "./wy-experience-and-automation-page-legacy.vue?vue&type=script&lang=js&"
export * from "./wy-experience-and-automation-page-legacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports